
















import { computed, defineComponent } from '@vue/composition-api';
import OlbButton from '../button';
import OlbIcon from '../icon';

export default defineComponent({
	components: {
		OlbButton,
		OlbIcon,
	},

	props: {
		value: {
			type: String,
			required: true,
		},
	},

	setup(props, { slots, emit }) {
		const slotNames = Object.keys(slots);

		const activeIndex = computed(() => {
			return slotNames.indexOf(props.value);
		});

		const isLast = computed(() => {
			return activeIndex.value >= slotNames.length - 1;
		});

		const next = () => {
			const nextIndex = slotNames.indexOf(props.value) + 1;
			emit('input', slotNames[nextIndex] ?? props.value);
		};

		const prev = () => {
			const prevIndex = slotNames.indexOf(props.value) - 1;
			emit('input', slotNames[prevIndex] ?? props.value);
		};

		return { activeIndex, isLast, next, prev };
	},
});
